import hu from './hu';
import en from './en';
import { commonI18n } from '@common/i18n';
import merge from 'deepmerge';

export default merge(commonI18n, { hu, en });
